import { FormValues, ValidationErrors } from './FormTypes';
import { validate } from 'validate.js';

// The ^ prevents from the field name to appear in the error message
export const errorMassages = {
  required:
    '^premium_plan.business_enterprise.request_call_form.validation_error.text',
  email:
    '^premium_plan.business_enterprise.request_call_form.validation_error.email',
  tel:
    '^premium_plan.business_enterprise.request_call_form.validation_error.tel',
  checkbox:
    '^premium_plan.business_enterprise.request_call_form.validation_error.checkbox',
  minLength:
    '^premium_plan.business_enterprise.request_call_form.validation_error.min_length',
  maxLength:
    '^premium_plan.business_enterprise.request_call_form.validation_error.max_length',
};

const presenceConstraint = {
  message: errorMassages.required,
  allowEmpty: false,
};

const lengthConstraint = (min: number, max: number) => {
  return {
    minimum: min,
    maximum: max,
    tooShort: errorMassages.minLength,
    tooLong: errorMassages.maxLength,
  };
};

const constraints = {
  bussinessEmail: {
    presence: presenceConstraint,
    email: {
      message: errorMassages.email,
    },
  },
  firstName: {
    presence: presenceConstraint,
    length: lengthConstraint(2, 50),
  },
  lastName: {
    presence: presenceConstraint,
    length: lengthConstraint(2, 50),
  },
  company: {
    length: lengthConstraint(0, 100),
  },
  phoneNumber: {
    presence: presenceConstraint,
    format: {
      pattern: '^[+]{0,1}[(]{0,1}[0-9]{1,4}[)]{0,1}[-./0-9]*$',
      flags: 'g',
      message: errorMassages.tel,
    },
  },
  checkbox: {
    presence: {
      message: errorMassages.checkbox,
    },
    inclusion: {
      within: [true],
      message: errorMassages.checkbox,
    },
  },
};

export const validateValues = (values: FormValues) => {
  const validationErrors = validate(values, constraints);
  const errors = {} as ValidationErrors;

  validationErrors &&
    Object.keys(validationErrors).map((formField) => {
      errors[formField] = validationErrors[formField][0];
    });

  return errors;
};
